// extracted by mini-css-extract-plugin
export var addToCartButton = "_t8-b";
export var arrowButtonContainer = "_t8-9";
export var arrowButtonIcon = "_t8-a";
export var carouselArrowButton = "_t8-6";
export var carouselElementContainer = "_t8-1";
export var left = "_t8-7";
export var productDisplayCarouselContainer = "_t8-0";
export var productTileContainer = "_t8-2";
export var productTileImage = "_t8-4";
export var productTileImageContainer = "_t8-3";
export var productTileTitle = "_t8-5";
export var right = "_t8-8";
export var sliderOverflow = "_t8-c";